import { createFileRoute } from "@tanstack/react-router"
import JoinCourse from "@/routes/-pages/JoinCourse"

export const Route = createFileRoute("/join-course")({
  component: JoinCourse,
})
